<mat-dialog-actions class="justify-content-between">
    <h3>{{ 'LABEL.SELECT_SUGGESTED_INVESTIGATION' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <div *ngIf="isLoading" class="loader-overlay">
        <div class="loader-content">
            <mat-spinner diameter="50"></mat-spinner>
        </div>
    </div>

    <div *ngIf="!isLoading && categories.length > 0" class="investigation-container">
        <!-- Category Tabs -->
        <mat-tab-group [(selectedIndex)]="selectedCategoryIndex" (selectedIndexChange)="onCategoryChange($event)">
            <mat-tab *ngFor="let category of categories" [label]="category.name">
                <div class="subcategory-list">
                    <mat-expansion-panel *ngFor="let subcategory of category.subcategories"
                        [expanded]="isSubcategoryExpanded(subcategory.id)"
                        (opened)="onSubcategoryToggle(subcategory.id, true)"
                        (closed)="onSubcategoryToggle(subcategory.id, false)" class="subcategory-panel">
                        <mat-expansion-panel-header class="bg-light-primary">
                            <mat-panel-title>
                                {{ subcategory.name }}
                                <span *ngIf="getSelectedCountForSubcategory(subcategory) > 0" class="selected-count">
                                    ({{ getSelectedCountForSubcategory(subcategory) }})
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div *ngIf="subcategory.items.length > 0" class="items-list">
                            <mat-checkbox *ngFor="let item of subcategory.items" [checked]="isItemSelected(item)"
                                (change)="onCheckboxChange(item, $event.checked)" class="item-checkbox">
                                {{ item.description }}
                            </mat-checkbox>
                        </div>

                        <div *ngIf="subcategory.items.length === 0" class="no-items-message">
                            <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div *ngIf="!isLoading && categories.length === 0" class="no-data-message">
        {{ 'LABEL.NO_DATA_AVAILABLE' | translate }}
    </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row m-t-4 p-r-16 w-100">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCancel()">
                {{ 'BUTTON.BTN_CLOSE' | translate }}
            </button>
            <button mat-flat-button color="primary" class="m-l-4" (click)="onSave()">
                {{ 'BUTTON.BTN_SELECT' | translate }}
            </button>
        </div>
    </div>
</mat-dialog-actions>